<template>
  <div
    id="mobile_nav"
    :class="[
      'mobile_nav',
      cut ? 'light' : 'dark',
      move ? 'move_top' : 'move_back',
    ]"
  >
    <img :src="logo" alt="" style="width: 1.4rem" />
    <div :style="{color:color,fontWeight:'700'}">鼎函科技</div>
    <div class="img_con"   @click="getMenu()">
      <img
      :src="menu"
      alt=""
      style="width: 1.1rem; "
    />
    </div>
    
    <mt-popup
      v-model="popupVisible"
      :class="['menu_pop', cut ? 'menu_bcg_light' : 'menu_bcg_dark']"
      pop-transition="popup-fade"
    >
      <div class="menu_list">
        <p
          :id="'menu_list_item_' + i"
          v-for="(item, i) in menu_list"
          :key="i"
          @click="goScroll(item)"
        >
          {{ item.name }}
        </p>
      </div>
    </mt-popup>
    <!-- <mt-popup v-model="popupVisible"  position="right">
      <div style="width: 5.43rem; height: 5.5rem; background: red"></div>
    </mt-popup> -->
  </div>
</template>

<script>
import { Popup } from "mint-ui";

export default {
  name: "",
  mixins: [],
  components: {
    Popup,
  },
  props: {
    theme_: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      popupVisible: false,
      theme: "light",
      cut: false,
      move: false,
      theme_obj: {
        light: {
          logo: require("../../assets/logo-light.png"),
          menu: require("../../assets/icon_menu.png"),
          color: '#FFFFFF',
        },
        dark: {
          logo: require("../../assets/dinghan-logo.png"),
          menu: require("../../assets/icon_menu_hover.png"),
          color: '#1A3862',
        },
      },
      // logo:'',
      // menu:'',
      dark_home: require("../../assets/home_dark.png"),
      light_home: require("../../assets/home_light.png"),
      menu_list: [
        { name: "产品服务", i: "0" },
        { name: "公司简介", i: "1" },
        { name: "保函服务", i: "1" },
        { name: "合作伙伴", i: "1" },
        { name: "最新动态", i: "2" },
      ],
    };
  },
  computed: {
    logo() {
      return this.theme_obj[this.theme].logo;
    },
    menu() {
      return this.theme_obj[this.theme].menu;
    },
    color() {
      return this.theme_obj[this.theme].color;

    }
  },
  watch: {
    theme: {
      handler(newVal, oldVal) {
        console.log("监听", newVal, oldVal);
      },
    },
  },
  created() {},
  mounted() {
    this.theme = this.theme_;
    this.onPageScroll();
    
  },
  methods: {
    onPageScroll() {
      let scroll = 0;
      let that = this;
      let dom = document.querySelector("#mobile_nav");
      let height = dom.getBoundingClientRect().height;
      window.addEventListener("scroll", function () {
        if (window.scrollY < height && window.scrollY > 0) {
          // 透明
          that.cut = true;
          that.move = false;
          that.theme = "dark";
        } else if (window.scrollY == height) {
          // 位移
          // that.move = true;
        } else if (window.scrollY > height) {
          // 回退
          if (window.scrollY < scroll) {
            that.$nextTick(() => {
              that.theme = "dark";
              that.cut = true;
              that.move = false;
            });
          } else if (window.scrollY >= scroll) {
            // 前进
            // that.move = true;
          }
        } else if (window.scrollY == 0) {
          that.cut = false;
          that.move = false;
          that.theme = "light";
        }
        scroll = window.scrollY;
      });
    },
    getMenu() {
      this.popupVisible = !this.popupVisible;
    },
    goScroll(item) {
      this.popupVisible = false;
      setTimeout(() => {
        let element = document.getElementById("title_" + item.i);
        element.scrollIntoView({
          behavior: "smooth",
        });
      }, 200);
    },
  },
};
</script>

<style scoped >
.mobile_nav {
  width: 100%;
  height: 2.4rem;
  /* background: rgb(26, 56, 98); */
  position: fixed;
  z-index: 9999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.8rem;
  box-sizing: border-box;
  left: 0;
  top: 0;
}
.light {
  background: rgb(255, 255, 255);
  box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
  /* animation: light_animate 3s linear normal; */
  transition: 0.4s ease-out;
}
.dark {
  background: rgb(255, 255, 255, 0.1);
  /* animation: dark_animate 0.6s linear normal; */
  transition: 0.4s ease-out;
}
.move_top {
  top: -2.4rem;
  animation: move_top 0.1s linear normal;
}
.move_back {
  top: 0;
  animation: move_back 0.1s linear normal;
}
@keyframes light_animate {
  from {
    background: rgb(255, 255, 255, 0.1);
  }
  to {
    background: rgb(255, 255, 255);
  }
}

@keyframes dark_animate {
  from {
    background: rgb(255, 255, 255);
  }
  to {
    background: rgb(255, 255, 255, 0.1);
  }
}

@keyframes move_top {
  from {
    top: 0;
  }
  to {
    top: -2.4rem;
  }
}
@keyframes move_back {
  from {
    top: -2.4rem;
  }
  to {
    top: 0;
  }
}
.menu_list {
  width: 6.7rem;
  height: 10.5rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}
.menu_pop {
  top: 2.4rem;
  right: 0;
  bottom: auto;
  left: auto;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  transition: 0.2s ease-out;
}
.menu_bcg_dark {
  background: rgb(255, 255, 255, 0.1);
  color: #fff;
  transition: 0.2s ease-out;
}
.menu_bcg_light {
  background: rgba(255, 255, 255, 1);
  color: #2b2b2b;
  transition: 0.2s ease-out;
}
.img_con{
  width: 2rem;
  display: flex;
  justify-content: flex-end;
}
/deep/.v-modal {
  opacity: 0;
}
</style>
